import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getIndustryList,
  createIndustry,
  updateIndustry,
  deleteIndustry,
} from "../api/industry.api";
import type { IndustryPayload, GetIndustryListParams } from "@/interface/masterManagement";
import { industryKeys, STALE_5_MIN } from "@/lib/queryKey";

export const useIndustryList = (params?: GetIndustryListParams) =>
  useQuery({
    queryKey: industryKeys.list(params || {}),
    queryFn: () => getIndustryList(params),
    ...STALE_5_MIN,
  });

export const useCreateIndustry = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createIndustry,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: industryKeys.lists() });
    },
  });
};

export const useUpdateIndustry = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: { id: number | string; payload: IndustryPayload }) =>
      updateIndustry(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: industryKeys.lists() });
    },
  });
};

export const useDeleteIndustry = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number | string) => deleteIndustry(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: industryKeys.lists() });
    },
  });
};
